import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';

import { assignCreatives } from '../creative-assets/actions';
import CreativeAssociations from './CreativeAssociations';

const mapStateToProps = (
  { creativeAssets: { creativesById }, campaignEditor: { campaignLinesById } },
  { countries },
) => {
  const lineIds = flatten(countries.map(ea => ea.lines));
  const lineSelection = lineIds.map(lineId => {
    const line = campaignLinesById[lineId];
    const label = line.country
      ? [line.country.name, line.gender].join(' ')
      : line.name;
    return { label, value: lineId };
  });
  const model = creativesById ? sortBy(Object.values(creativesById), 'id') : [];
  return { model, lines: lineSelection };
};
const mapDispatchToProps = {
  assignCreatives,
};

const CreativeAssociationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreativeAssociations);

// NOTE: would be cleaner if /creatives return all Campaign related creatives with product key field for FE sorting
export default CreativeAssociationsContainer;
